export default "__VITE_ASSET__D6Rn3ilh__"